import React from 'react';

import { Box, H1, Text } from '@betterment/samba-react';
import { Helmet } from 'react-helmet';

const NotFound: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box
      css={{
        display: 'flex',
        height: '100vh',
        backgroundColor: 'background.surface',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <Box>
        <H1 css={{ textAlign: 'center' }}>404</H1>
        <Text as="p" css={{ textAlign: 'center' }}>
          The page you're looking for isn't here. Sorry about that.
        </Text>
      </Box>
    </Box>
  );
};

export default NotFound;
